import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * Returns the current environment path prefix.
 * Use this in any page to get env-aware paths.
 */
export function useEnvPrefix() {
  const location = useLocation();
  return location.pathname.startsWith('/test') ? '/test' : '';
}

/**
 * Environment-aware navigate. Prepends /test when in test environment.
 */
export function useEnvNavigate() {
  const navigate = useNavigate();
  const prefix = useEnvPrefix();
  return useCallback(
    (path, options) => navigate(prefix + path, options),
    [navigate, prefix]
  );
}
